import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsPageWrapper from "../../shared/SettingsPageWrapper";
import TagsManager from "../shared/components/TagsManager";

const SettingsTagsDetailsApp = ({ settingsPath, ...tagsProps }) => (
  <>
    <ToastContainer icon={false} />
    <SettingsPageWrapper settingsPath={settingsPath} title="Tags">
      <TagsManager {...tagsProps} />
    </SettingsPageWrapper>
  </>
);

export default SettingsTagsDetailsApp;
